import { PayloadAction } from '@reduxjs/toolkit';
import { SelectedVisitState } from './selectedVisitInterface';
import { selectedVisitInitialStateValue } from './selectedVisitInitialState';

export const selectedVisitDetails = (
  state: SelectedVisitState,
  action: PayloadAction<Partial<SelectedVisitState>>,
) => {
  return { ...state, ...action.payload };
};

export const latestNoteStatus = (
  state: SelectedVisitState,
  action: PayloadAction<Partial<{ status?: number; createdAt?: string; noteId: string }>>,
) => {
  if (state.uuid !== action.payload.noteId) {
    return { ...state };
  }

  return {
    ...state,
    noteStatus: action.payload.status,
    latestNoteStatus: action.payload,
  };
};

export const latestNoteStatusFailed = (
  state: SelectedVisitState,
  _: PayloadAction<Partial<{ error: string; noteId: string }>>,
) => {
  return state;
};

export const clearState = (state: SelectedVisitState) => {
  Object.assign(state, selectedVisitInitialStateValue);
};
